import { Menu, MessageSquare } from 'lucide-react'

// Mobile bottom navigation bar
export function MobileBottomNav({
  onMenuClick,
  onChatClick,
}: {
  onMenuClick: () => void
  onChatClick: () => void
}) {
  return (
    // The h-16 row below stays the content box; the safe-area padding adds
    // BELOW it so the buttons clear the device home indicator.
    <div className="fixed bottom-0 left-0 right-0 z-50 bg-white border-t border-gray-200 pb-[env(safe-area-inset-bottom)] md:hidden">
      <div className="flex items-center justify-around h-16 px-4">
        <button
          onClick={onMenuClick}
          className="flex flex-col items-center justify-center gap-1 px-6 py-2 text-gray-600 hover:text-gray-900 active:bg-gray-100 rounded-lg transition-colors"
          aria-label="Open navigation menu">
          <Menu className="w-6 h-6" />
          <span className="text-xs font-medium">Menu</span>
        </button>

        <button
          onClick={onChatClick}
          className="flex flex-col items-center justify-center gap-1 px-6 py-2 text-gray-600 hover:text-gray-900 active:bg-gray-100 rounded-lg transition-colors"
          aria-label="Open chat">
          <MessageSquare className="w-6 h-6" />
          <span className="text-xs font-medium">Chat</span>
        </button>
      </div>
    </div>
  )
}
